import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=18fb5e2e&scoped=true&"
var script = {}
import style0 from "./topbar.vue?vue&type=style&index=0&id=18fb5e2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb5e2e",
  null
  
)

export default component.exports